import { useSession } from 'src/app/hooks/useSession';
import { ShowUserAdmin } from './ShowUserAdmin';
import { UsersShowStudent } from './users-show-student';

export function UsersShow() {
  const { session } = useSession();

  if (session.user.profileNames.includes('Aluno')) {
    return <UsersShowStudent />;
  } else {
    return <ShowUserAdmin />;
  }
}
